import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9fe1b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left" }
const _hoisted_2 = { class: "hello" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的工作台", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "empty-works"
}
const _hoisted_9 = { style: {"text-align":"center"} }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "not-power"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "not-power"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 2,
  class: "empty-process"
}
const _hoisted_18 = {
  key: 1,
  class: "not-power"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_order_pool_choose_service = _resolveComponent("order-pool-choose-service")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_date_choose = _resolveComponent("miezz-date-choose")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_order_pool_process = _resolveComponent("order-pool-process")!
  const _component_order_process = _resolveComponent("order-process")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_miezz_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.logier?.UserName) + ", " + _toDisplayString(_ctx.hello), 1),
          _createVNode(_component_miezz_button, {
            model: _ctx.btnAdd,
            onHandleClick: _ctx.handleClick
          }, null, 8, ["model", "onHandleClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_miezz_button, {
              model: _ctx.btnWorkSetting,
              onHandleClick: _ctx.handleClick
            }, null, 8, ["model", "onHandleClick"])
          ]),
          (_ctx.myWorks.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myWorks, (item, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: i,
                    class: _normalizeClass(`work${item.Value == _ctx.activeWork ? ' active' : ''}`),
                    style: _normalizeStyle(`width: ${100 / _ctx.myWorks.length}%`),
                    onClick: ($event: any) => (_ctx.changeActiveWork(item.Value))
                  }, [
                    _createTextVNode(_toDisplayString(item.Label) + " ", 1),
                    (item.Data)
                      ? (_openBlock(), _createBlock(_component_el_badge, {
                          key: 0,
                          "is-dot": true
                        }))
                      : _createCommentVNode("", true)
                  ], 14, _hoisted_7))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "请点击右侧设置按钮添加快捷内容"))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalChooseService,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalChooseService) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_order_pool_choose_service, {
          modelValue: _ctx.modalChooseService,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalChooseService) = $event)),
          onHandleSubmit: _ctx.handleChooseServiceSubmit
        }, null, 8, ["modelValue", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalWorkSetting,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalWorkSetting) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: "请选择要添加的内容",
          type: "info",
          effect: "light",
          style: {"margin-bottom":"10px"},
          closable: false
        }),
        _createVNode(_component_miezz_page_list, {
          modelValue: _ctx.listWorkSetting,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listWorkSetting) = $event))
        }, {
          column: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_9, _toDisplayString(row.Label), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.activeWork == 'PlanBulletinBoard')
      ? (_openBlock(), _createBlock(_component_miezz_card, {
          key: 0,
          fix: true,
          fixTop: "150px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_miezz_date_choose, {
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.date) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_miezz_page_list, {
                modelValue: _ctx.listPlanBulletinBoard,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listPlanBulletinBoard) = $event)),
                className: "plan-bulletin-board",
                onHandleRowClick: _ctx.clickOrderPlanBulletinBoard
              }, {
                column: _withCtx(({ model, row }) => [
                  (
                model.Prop == 'ClientCompany' && row.ClientCompanies.length > 0
              )
                    ? (_openBlock(), _createBlock(_component_el_popover, {
                        key: 0,
                        placement: "top-start",
                        trigger: "hover",
                        disabled: row.ClientCompanies.length == 1,
                        "popper-class": "popover-tooltip",
                        effect: "dark"
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_miezz_text_ellipsis, {
                            text: row.ClientCompany
                          }, null, 8, ["text"])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.ClientCompanies, (item, i) => {
                            return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(item), 1))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["disabled"]))
                    : (model.Prop == 'ClientCompany' && row.ClientCompany)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(row.ClientCompany), 1))
                      : (model.Prop == 'ClientCompany')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "暂无数据"))
                        : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue", "onHandleRowClick"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.activeWork == 'OrderPoolTask')
      ? (_openBlock(), _createBlock(_component_miezz_card, {
          key: 1,
          fix: true,
          fixTop: "150px"
        }, {
          default: _withCtx(() => [
            (_ctx.powers.contains('OrderManagement_Pool_Task'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    underline: false,
                    href: "/#/order/pool",
                    style: {"float":"right"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("More")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_miezz_page_list, {
                    modelValue: _ctx.listOrderPoolTask,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listOrderPoolTask) = $event)),
                    onHandleRowClick: _ctx.clickOrderPoolTask
                  }, null, 8, ["modelValue", "onHandleRowClick"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, "无相关信息查看权限"))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.activeWork == 'OrderTask')
      ? (_openBlock(), _createBlock(_component_miezz_card, {
          key: 2,
          fix: true,
          fixTop: "150px"
        }, {
          default: _withCtx(() => [
            (_ctx.powers.contains('OrderManagement_Order_Task'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    underline: false,
                    href: "/#/order",
                    style: {"float":"right"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("More")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_miezz_page_list, {
                    modelValue: _ctx.listOrderTask,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listOrderTask) = $event)),
                    onHandleRowClick: _ctx.clickOrderTask
                  }, null, 8, ["modelValue", "onHandleRowClick"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, "无相关信息查看权限"))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.activeWork == 'Process')
      ? (_openBlock(), _createBlock(_component_miezz_card, {
          key: 3,
          fix: true,
          fixTop: "150px"
        }, {
          default: _withCtx(() => [
            (
          _ctx.powers.contains('OrderManagement_Pool_Process') ||
          _ctx.powers.contains('OrderManagement_Order_Process')
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_el_form, {
                    model: _ctx.formProcess,
                    ref: "refFormProcess",
                    rules: _ctx.rulesProcess,
                    "label-width": "150px",
                    inline: true
                  }, {
                    default: _withCtx(() => [
                      (_ctx.logier?.CompanyType == _ctx.EnumCompanyType.Customer)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "我的编号",
                            prop: "MyCode"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.formProcess.MyCode,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formProcess.MyCode) = $event)),
                                onHandleBlur: _ctx.handleBlurMyCode
                              }, null, 8, ["modelValue", "onHandleBlur"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.logier?.CompanyType == _ctx.EnumCompanyType.Customer)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "Booking No",
                            prop: "Code"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.formProcess.Code,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formProcess.Code) = $event)),
                                fetchSuggestions: _ctx.querySearchCode,
                                triggerOnFocus: true,
                                valueKey: "Value"
                              }, null, 8, ["modelValue", "fetchSuggestions"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.logier?.CompanyType == _ctx.EnumCompanyType.ServiceProvider)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: "编号",
                            prop: "Code"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.formProcess.Code,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formProcess.Code) = $event)),
                                style: {"width":"300px"},
                                placeholder: '请填写Booking No、订单编号或提单号码'
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_button, {
                            model: _ctx.btnSearchProcess,
                            onHandleClick: _ctx.handleClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("搜索")
                            ]),
                            _: 1
                          }, 8, ["model", "onHandleClick"])
                        ]),
                        _: 1
                      }),
                      (_ctx.formCallbackProcess.PoolId)
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 3,
                            type: "primary",
                            underline: false,
                            href: `/#/order/pool/summary/${_ctx.formCallbackProcess.PoolId}`,
                            style: {"float":"right"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("More")
                            ]),
                            _: 1
                          }, 8, ["href"]))
                        : (_ctx.formCallbackProcess.OrderId)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 4,
                              type: "primary",
                              underline: false,
                              href: `/#/order/summary/${_ctx.formCallbackProcess.OrderId}`,
                              style: {"float":"right"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("More")
                              ]),
                              _: 1
                            }, 8, ["href"]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["model", "rules"]),
                  (_ctx.formCallbackProcess.PoolId)
                    ? (_openBlock(), _createBlock(_component_order_pool_process, {
                        key: 0,
                        id: _ctx.formCallbackProcess.PoolId
                      }, null, 8, ["id"]))
                    : (_ctx.formCallbackProcess.OrderId)
                      ? (_openBlock(), _createBlock(_component_order_process, {
                          key: 1,
                          id: _ctx.formCallbackProcess.OrderId
                        }, null, 8, ["id"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, "无匹配的信息"))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, "无相关信息查看权限"))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}